import { render } from "./TheFooter.vue?vue&type=template&id=62f5a93a&scoped=true"
import script from "./TheFooter.vue?vue&type=script&lang=js"
export * from "./TheFooter.vue?vue&type=script&lang=js"

import "./TheFooter.vue?vue&type=style&index=0&id=62f5a93a&lang=scss&scoped=true"

import exportComponent from "/Users/konatsu/docker-static/speedo.devs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62f5a93a"]])

export default __exports__